import styled, { css } from "styled-components";
import Autocomplete from "ui/common/components/input/Autocomplete/Autocomplete";

export const SearchInputRoot = styled(Autocomplete)(
    () => css`
        width: 100%;
        background-color: white;
        border-radius: 21px;
        outline: none;
        height: 30px !important;

        .SelectDisplay {
            height: 30px !important;
            min-height: auto;
            border: none !important;
            padding: 0px 10px !important;
        }

        .SelectItem {
            font-size: 0.8rem !important;
        }

        input {
            height: 100%;
            font-size: 0.8rem !important;
            font-weight: 500 !important;
            &::placeholder {
                font-size: 0.8rem !important;
                color: #adadadc9 !important;
                font-weight: 500 !important;
            }
        }
    `,
);
